import type ExcelJS from 'exceljs';

export function worksheetToAOA(ws: ExcelJS.Worksheet): any[][] {
  const rows: any[][] = [];
  ws.eachRow({ includeEmpty: true }, (row) => {
    rows.push((row.values as any[]).slice(1));
  });
  return rows;
}

export function worksheetToJSON(ws: ExcelJS.Worksheet): Record<string, any>[] {
  const rows = worksheetToAOA(ws);
  if (rows.length === 0) return [];
  const headers = rows[0].map((h: any) => String(h ?? ''));
  return rows.slice(1).map(row => {
    const obj: Record<string, any> = {};
    headers.forEach((h, i) => { obj[h] = row[i] ?? ''; });
    return obj;
  });
}
